<template>
  <div class="consulAddDialog">
    <div ref="meetingForm">
    <div class="basicTitle">天长市农村社区协商议题办理结果公示单</div>
    <div class="basicSubTitle">社区：{{communityName}}</div>
    <div class="basicGongShi">
      <p class="gongShiContent">
        <span>{{gongShiYear}}</span>年
        <span>{{gongShiMonth}}</span>月
        <span>{{gongShiDay}}</span>日，就反映的
        <span class="zdts">&nbsp;&nbsp;{{content}}&nbsp;&nbsp;</span>问题，召集有关人员进行协商，会上，通过无记名投票的方式，与会人员就
        <span class="zdts">&nbsp;&nbsp;{{content}}&nbsp;&nbsp;</span>问题达成共识，决定：
      </p>
      <p class="gongShiContent">
        <span>{{publicityContent}}</span>
      </p>
      <!-- <p class="gongShiContent">
        <span>{{jueyi1}}</span>
      </p>
      <p class="gongShiContent">
        <span>{{jueyi2}}</span>
      </p>
       <p class="gongShiContent">
        <span>{{jueyi3}}</span>
      </p>
       <p class="gongShiContent">
        <span>{{jueyi4}}</span>
      </p>
       <p class="gongShiContent">
        <span>{{jueyi5}}</span>
      </p>
       <p class="gongShiContent">
        <span>{{jueyi6}}</span>
      </p> -->
      <p class="gongShiContent">特此公示。</p>
      <p class="gongShiContent">如有疑问，请向社区居委会或居民监督委员会反映。</p>
      <div class="gongShiWeiKuan">
        <p>{{communityName}}协商委员会</p>
        <p>
          <span>{{gongShiYear}}</span>年
          <span>{{gongShiMonth}}</span>月
          <span>{{gongShiDay}}</span>日
        </p>
      </div>
    </div>
    </div>
    <div class="queRenBtn">
        <el-button type="primary" style='margin: 0 0px' @click="dayin">打印</el-button>
      <!-- <el-button type="primary" style='margin: 0 30px' @click="onSave">确认</el-button> -->
      <el-button type="info" @click="quxiao">取消</el-button>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid"],
  data() {
    return {
      id: this.ytid,
      radio: "1",
      gongShiProblem: "垃圾乱扔乱倒",
      gongShiYear: "2020",
      gongShiMonth: "9",
      gongShiDay: "5",
      ghuiYiProblem: "垃圾乱扔乱倒",
      publicityContent:'',
      // jueyi1: "",
      // jueyi2: "",
      // jueyi3: "",
      // jueyi4: "",
      // jueyi5: "",
      // jueyi6: "",
      communityName: "",
      content: "",
      publicityTime: "",
      gongShiYear: '', 
      gongShiMonth: '', 
      gongShiDay: '', 
      approvalStatus: '',
      approvalOpinion: ''
    };
  },
  methods: {
    getGongShiInfo() {
      post("/admin/consultPublicity/info/getConsultPublicity",{
        consultId: this.ytid,
      }).then(res => {
        this.communityName = res.content.communityName;
        this.content = res.content.content;
        this.publicityContent = res.content.publicityContent
        this.publicityTime = res.content.publicityTime.split('-');
        this.gongShiYear = this.publicityTime[0];
        this.gongShiMonth = this.publicityTime[1];
        this.gongShiDay = this.publicityTime[2]; 
        // this.jueyi1 = this.publicityContent[0];
        // this.jueyi2 = this.publicityContent[1];
        // this.jueyi3 = this.publicityContent[2];
        // this.jueyi4 = this.publicityContent[3];
        // this.jueyi5 = this.publicityContent[4];
        // this.jueyi6 = this.publicityContent[5];
      })
    },
    // getFindConsultById() {
    //     console.log(this.id)
    //     post("/admin/consult/info/findConsultById",{
    //       id: this.ytid
    //     }).then(res => {
    //       this.approvalStatus = res.content.approvalStatus;
    //       console.log(res.content.approvalStatus)
    //       this.consultName = res.content.consultName;
    //       if(res.content.communityId == '2'){
    //         this.communityName = '浔河社区';
    //       }else if(res.content.communityId == '20'){
    //         this.communityName = '石街社区';
    //       }
    //     })
    //   },
     dayin() {
        this.$print(this.$refs.meetingForm);
      },
    onSave() {
      if(this.approvalStatus == '') {
        this.$message.error({
          message:'请选择审核结果'
        })
        return false
      }
      post("/admin/consultPublicity/info/updateConsultPublicity",{
        consultId: this.ytid,
        approvalStatus: this.approvalStatus,
        approvalOpinion: this.approvalOpinion
      }).then(res => {
        console.log(res)
        this.$emit("close")
      })
    },
    quxiao() {
      this.$emit("close")
    }
  },
  mounted() {
    this.getGongShiInfo();
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
  margin: 40px;
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicTitle {
  font-size: 25px;
  text-align: center;
}
.basicSubTitle {
  font-size: 22px;
  margin-bottom: 20px;
}
.basicGongShi {
  border: 1px solid #000;
  // width: 980px;
  font-size: 18px;
  padding: 5px 25px;
  .gongShiContent {
    min-width: 200px;
    line-height: 50px;
    text-indent: 60px;
  }
  .gongShiWeiKuan {
    line-height: 25px;
    // margin-top: 330px;
    text-align: right;
    p {
      margin: 20px;
    }
  }
}
.queRenBtn {
  margin: 60px 0;
   margin-top: 30px;
  display: flex;
  justify-content: center;
} 
</style>